// extracted by mini-css-extract-plugin
export default {"root":"Blocks_root__2KiU0","text":"Blocks_text__3bt6z","bg":"Blocks_bg__3bjtl","link":"Blocks_link__pshfg","title":"Blocks_title__2KUgb"};